//import {default as moment, Moment} from 'moment';
//import _date = moment.unitOfTime._date;

export class ChartDataRow {
    constructor(
        public readonly date: any,
        public readonly bufferG: number,
        public readonly bufferY: number,
        public readonly bufferR: number,
        public readonly safetyBuffer: number,
        public readonly actionBuffer: number,
        public readonly valueOut: number,
        public readonly valueIn: number,
        public readonly checkedBalance: number,
        public readonly noData: number,
        public readonly noDataBool: number,
        public readonly balance: number,
        public readonly targetStockLevel: number,
        public readonly packageValue: number,
        public readonly replenishmentTime: number,
        public readonly shelfQuantity: number,
        public readonly actionSafetyBuffer: number,
        public readonly maxQuantity: number,
        public readonly maxBuffer: number,
        public readonly minBuffer: number,
        public readonly qntOut1: number,
        public readonly qntOut2: number,
        public readonly discountQnt: number,
        public readonly realBuff: number,
        public readonly checkedSales: number,
        public readonly avgToReplenishment: number,
        public readonly transit: number,
        public readonly bufferGBT: number,
        public readonly bufferABT: number,
        public readonly bufferASBT: number,
        public readonly actionBalance: number,
        public readonly actionTransit: number,

        public readonly action: boolean,
        public readonly season: boolean,
        public readonly vacation: boolean,
        public readonly holiday: boolean,
        public readonly orderDay: boolean,
        public readonly deliveryDay: boolean,
        public readonly bufferGrowFixed: boolean,
        public readonly bufferDecreaseFixed: boolean,
        public readonly firstPriceItem: boolean

    ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data-row.ts